// extracted by mini-css-extract-plugin
export default {"filesUpload":"DialogFirsMessage_filesUpload__wqxhL","dialogActions":"DialogFirsMessage_dialogActions__Sxa9n","warningFile":"DialogFirsMessage_warningFile__45kMG"};